// src/components/Faq.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Accordion } from 'react-bootstrap';

const Faq = () => {
    const { t } = useTranslation();
    
    const faqItems = [
        { eventKey: "0", question: t('faq1_question'), answer: t('faq_answer') },
        { eventKey: "1", question: t('faq2_question'), answer: t('faq_answer') },
        { eventKey: "2", question: t('faq3_question'), answer: t('faq_answer') },
        { eventKey: "3", question: t('faq4_question'), answer: t('faq_answer') },
    ];
    return (
        <section className="faq-con position-relative float-left w-100 main-box padding-top padding-bottom">
            <Container className="wow animate__animated animate__fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                <div className="row">
                    <div className="col-xl-7 col-lg-10 col-12 mx-auto">
                        <div className="faq_content text-center">
                            <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft" data-wow-duration="2s" data-wow-delay="0.2s">{t('faq_title')}</span>
                            <h2 className="wow animate__animated animate__fadeInRight" data-wow-duration="2s" data-wow-delay="0.4s" dangerouslySetInnerHTML={{__html: t('faq_subtitle')}}></h2>
                        </div>
                    </div>
                </div>
                <div className="faq wow animate__animated animate__fadeInDown" data-wow-duration="2s" data-wow-delay="0.2s">
                    <div className="col-xl-8 col-lg-10 col-md-12 col-sm-12 col-12 mx-auto">
                        <Accordion defaultActiveKey="1">
                            {faqItems.map(item => (
                                <Accordion.Item eventKey={item.eventKey} key={item.eventKey} className="accordion-card mb-3">
                                    <Accordion.Header>
                                        {item.question}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p className="text-size-16 text-left mb-0">
                                            {item.answer}
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default Faq;